import { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { api } from "../lib/api";
import { BreadcrumbJsonLd, ItemListJsonLd } from "../components/JsonLd";

export default function Browse() {
  const [params, setParams] = useSearchParams();
  const q = params.get("q") || "";
  const category = params.get("category") || "All";
  const [cats, setCats] = useState(["All"]);
  const [videos, setVideos] = useState([]);
  const [channels, setChannels] = useState([]);

  useEffect(() => {
    api.get("/categories").then(r => setCats(r.data.categories));
    api.get("/channels").then(r => setChannels(r.data));
  }, []);

  useEffect(() => {
    const qs = new URLSearchParams();
    if (q) qs.set("q", q);
    if (category && category !== "All") qs.set("category", category);
    api.get(`/videos?${qs.toString()}`).then(r => setVideos(r.data));
  }, [q, category]);

  const setQ = (v) => { const p = new URLSearchParams(params); if (v) p.set("q", v); else p.delete("q"); setParams(p); };
  const setCat = (c) => { const p = new URLSearchParams(params); p.set("category", c); setParams(p); };

  return (
    <div className="max-w-[1400px] mx-auto px-6 py-8">
      <BreadcrumbJsonLd items={[{ name: "Accueil", path: "/" }, { name: "Explorer", path: "/search" }]} />
      <ItemListJsonLd
        name={q ? `Recherche Fedevo 2.0 : "${q}"` : "Catalogue Fedevo 2.0 · Média urbain spécialisé streaming"}
        items={videos.map(v => ({
          name: v.title,
          path: `/watch/${v.id}`,
          image: v.thumbnail,
        }))}
      />
      <h1 className="font-display text-5xl mb-6">Explorer</h1>
      <input
        data-testid="browse-search-input"
        value={q}
        onChange={e => setQ(e.target.value)}
        placeholder="Tapez pour filtrer les vidéos..."
        className="w-full bg-[color:var(--bg-elev)] border border-[color:var(--border)] rounded-full px-5 py-3 mb-5 focus:outline-none focus:border-[color:var(--accent)] transition"
      />
      <div className="flex flex-wrap gap-2 mb-8">
        {cats.map(c => (
          <button
            key={c}
            data-testid={`cat-${c}`}
            onClick={() => setCat(c)}
            className={`px-4 py-1.5 rounded-full text-xs uppercase tracking-widest border transition ${
              category === c ? 'bg-[color:var(--accent)] text-white border-[color:var(--accent)]' : 'border-[color:var(--border)] hover:border-white'
            }`}
          >{c === "All" ? "Tous" : c}</button>
        ))}
      </div>
      {videos.length === 0 ? (
        <div className="text-center py-20 text-[color:var(--text-muted)]">Aucune vidéo trouvée.</div>
      ) : (
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-5 stagger">
          {videos.map(v => {
            const ch = channels.find(c => c.id === v.channel_id);
            return (
              <Link key={v.id} to={`/watch/${v.id}`} className="card-hover rounded-xl overflow-hidden border border-[color:var(--border)] bg-[color:var(--bg-elev)]">
                <div className="aspect-video bg-black">
                  {v.thumbnail && <img src={v.thumbnail} alt="" className="w-full h-full object-cover" />}
                </div>
                <div className="p-4">
                  <div className="font-medium line-clamp-2">{v.title}</div>
                  {ch && <div className="text-xs text-[color:var(--text-muted)] mt-1">{ch.name}</div>}
                </div>
              </Link>
            );
          })}
        </div>
      )}
    </div>
  );
}
